import { useState } from "react";
import axios from "axios";

export default function IftarReset() {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [confirm, setConfirm] = useState(false);

  const handleReset = async () => {
    if (!confirm) {
      setConfirm(true);
      return;
    }

    setLoading(true);
    setDone(false);
    setError("");
    setConfirm(false);

    try {
      await axios.post(
        `${process.env.REACT_APP_PATH_DESTINATION}/iftarExchangeReset`
      );
      await axios.post(
        `${process.env.REACT_APP_PORTAL_DESTINATION}/ailiveshowclear`
      );
      setDone(true);
    } catch (err) {
      console.error(err);
      setError("Reset failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setConfirm(false);
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #07111f 0%, #0a1628 60%, #061018 100%)",
      fontFamily: "'Segoe UI', system-ui, sans-serif",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "28px",
      padding: "32px 20px",
      boxSizing: "border-box",
    }}>

      {/* Header */}
      <div style={{ textAlign: "center" }}>
        <p style={{
          margin: "0 0 6px",
          fontSize: "11px",
          letterSpacing: "3px",
          color: "rgba(255,255,255,0.3)",
          textTransform: "uppercase",
        }}>Iftar Exchange 2026</p>
        <h2 style={{
          margin: 0,
          fontSize: "clamp(18px, 2.5vw, 26px)",
          fontWeight: "700",
          color: "#e8c84a",
          letterSpacing: "0.3px",
        }}>Session Reset</h2>
      </div>

      {/* Info card */}
      <div style={{
        width: "100%",
        maxWidth: "420px",
        background: "rgba(255, 80, 80, 0.04)",
        border: "1px solid rgba(255, 80, 80, 0.15)",
        borderRadius: "12px",
        padding: "20px 24px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}>
        <p style={{
          margin: 0,
          fontSize: "11px",
          letterSpacing: "2px",
          color: "rgba(255,100,100,0.6)",
          textTransform: "uppercase",
        }}>This action will</p>
        {[
          "Reset row index on iftar_speak_row",
          "Reset status on iftar_status",
          "Remove all data in iftar_summarize",
        ].map((item, i) => (
          <div key={i} style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}>
            <div style={{
              width: "5px",
              height: "5px",
              borderRadius: "50%",
              background: "rgba(255,100,100,0.5)",
              flexShrink: 0,
            }} />
            <span style={{
              fontSize: "13px",
              color: "rgba(255,255,255,0.5)",
            }}>{item}</span>
          </div>
        ))}
      </div>

      {/* Confirm state */}
      {confirm && !loading && (
        <div style={{
          width: "100%",
          maxWidth: "420px",
          background: "rgba(255,80,80,0.07)",
          border: "1px solid rgba(255,80,80,0.35)",
          borderRadius: "10px",
          padding: "16px 20px",
          textAlign: "center",
          animation: "fadeIn 0.25s ease",
        }}>
          <p style={{
            margin: "0 0 14px",
            fontSize: "13px",
            color: "rgba(255,180,180,0.9)",
            letterSpacing: "0.3px",
          }}>Are you sure? This cannot be undone.</p>
          <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
            <button
              onClick={handleReset}
              style={{
                padding: "10px 24px",
                background: "rgba(255,60,60,0.85)",
                border: "none",
                borderRadius: "7px",
                color: "#fff",
                fontWeight: "700",
                fontSize: "12px",
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                cursor: "pointer",
              }}
            >
              Yes, Reset
            </button>
            <button
              onClick={handleCancel}
              style={{
                padding: "10px 24px",
                background: "transparent",
                border: "1px solid rgba(255,255,255,0.15)",
                borderRadius: "7px",
                color: "rgba(255,255,255,0.5)",
                fontWeight: "600",
                fontSize: "12px",
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* ALL RESET Button */}
      {!confirm && (
        <button
          onClick={handleReset}
          disabled={loading}
          style={{
            padding: "14px 40px",
            background: loading
              ? "rgba(255,80,80,0.1)"
              : "linear-gradient(135deg, #ff4f4f 0%, #c0392b 100%)",
            border: loading ? "1px solid rgba(255,80,80,0.35)" : "none",
            borderRadius: "8px",
            color: loading ? "rgba(255,100,100,0.8)" : "#fff",
            fontWeight: "700",
            fontSize: "14px",
            letterSpacing: "2.5px",
            textTransform: "uppercase",
            cursor: loading ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            transition: "all 0.2s ease",
            boxShadow: loading ? "none" : "0 4px 24px rgba(255,60,60,0.35)",
          }}
        >
          {loading ? (
            <>
              <span style={{ animation: "spin 1s linear infinite", display: "inline-block", fontSize: "16px" }}>⟳</span>
              Resetting...
            </>
          ) : (
            <>⚠ All Reset</>
          )}
        </button>
      )}

      {/* Success */}
      {done && !error && (
        <p style={{
          margin: 0,
          fontSize: "13px",
          color: "#6ee7b7",
          letterSpacing: "1px",
          animation: "fadeIn 0.3s ease",
        }}>
          ✓ Session has been reset successfully.
        </p>
      )}

      {/* Error */}
      {error && (
        <p style={{
          margin: 0,
          fontSize: "13px",
          color: "#ff6b6b",
          background: "rgba(255,80,80,0.08)",
          padding: "10px 18px",
          borderRadius: "6px",
          border: "1px solid rgba(255,80,80,0.25)",
          animation: "fadeIn 0.3s ease",
        }}>{error}</p>
      )}

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}